import { render, staticRenderFns } from "./PivniceTeplota.vue?vue&type=template&id=0207b0d2&scoped=true&"
import script from "./PivniceTeplota.vue?vue&type=script&lang=js&"
export * from "./PivniceTeplota.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0207b0d2",
  null
  
)

export default component.exports